import { createApp } from 'vue'
import store from 'store'

import CheckoutComplete from './CheckoutComplete.vue'

const el = 'checkout-complete'
const DOM = document.querySelector(el)

const render = function() {
    if (DOM) {
        const app = createApp(CheckoutComplete, {
            termsUrl: DOM.getAttribute('data-terms-url'),
            privacyUrl: DOM.getAttribute('data-privacy-url'),
            initialDiscountCode: DOM.getAttribute('data-discount-code') || ''
        })
        app.use(store)
        app.mount(el)
    }
}

export default {
    render
}

